import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { Button, OverlayTrigger, Popover } from "react-bootstrap";
import CommentItem from "./CommentItem";
import { toDateTimeStamp } from "../../utils/utils";
import Loader from "./Loader";
import { getCommentsByMeetingId } from "../../ducks/advisoryGroup";

const CommentPopOver = ({ data, ...props }) => {
    const dispatch = useDispatch();
    const { meetingId, agMemberId, linkType } = data;

    const [showPopover, setShowPopover] = useState(false);

    const memberMeetingComments = useSelector((state) => state.advisoryGroup?.commentList);
    const isMeetingCommentsExist = memberMeetingComments?.[meetingId];
    

    useEffect(() => {
        if (showPopover && typeof isMeetingCommentsExist === 'undefined') {
            dispatch(getCommentsByMeetingId({ meetingId, agMemberId, linkType }));
        }
    }, [showPopover, isMeetingCommentsExist, dispatch, meetingId]);

    useEffect(() => {
        const handleClickOutside = () => setShowPopover(false);
        document.getElementById('attendance-details-modal').addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleComment = (nextShow) => {
        setShowPopover(nextShow);
      };

    const popover = (
        <Popover>
            <Popover.Body>
                {typeof isMeetingCommentsExist === 'undefined' ? <Loader size={1} /> : isMeetingCommentsExist?.length > 0 ?
                    isMeetingCommentsExist.map((comment) => (
                        <CommentItem
                            key={comment.id}
                            id={comment.id}
                            date={toDateTimeStamp(comment.recordCreated)}
                            userName={`${comment.firstName} ${comment.lastName}`}>
                            {comment.comments}
                        </CommentItem>
                    )) : 'No comments'}
            </Popover.Body>
        </Popover>
    );

    return (
        <OverlayTrigger
            placement="bottom"
            trigger="click"
            show={showPopover}
            onToggle={handleComment}
            overlay={popover}
            rootClose
        >
            <Button {...props}>{props.children}</Button>
        </OverlayTrigger>
    );
};

export default CommentPopOver;
